import BillUploadDetail from "./BillUploadDetail";

export default BillUploadDetail;
